import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService, UserService } from '../..';
import { Jsonp, RequestOptions, Http, Headers, ResponseContentType } from '@angular/http';

@Injectable()
export class LaychisoService {
  constructor(private router: Router, private api: ApiService, private userService: UserService) { }


  uploadExcelReturnJson(desFolder: string, overWrite: string, file: File, thang) {
    var para = JSON.stringify({
      v_thang: thang
    });
    let formData: FormData = new FormData();

    formData.append('uploadFile', file, file.name);
    formData.append('Desfolder', desFolder);
    formData.append('overWrite', overWrite);
    formData.append('config', JSON.stringify({ namesql: "PKG_CHISO_AMATA.LAYSCHISO_AMATA" }));
    formData.append('table', "BT_CHISO_AMATA");
    formData.append('para', para);
    let headers = new Headers()
    //headers.append('Content-Type', 'json');  
    //headers.append('Accept', 'application/json');  

    let options = new RequestOptions({ headers: headers });
    return this.api.Excute("api/UploadFilesExcel", formData, options);
  }

}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/services/tien-ich/lay-chi-so/laychiso.service.ts